import {DoNotDisturb} from "@mui/icons-material";
import {Chip} from "@mui/material";
import React from "react";
import {useLocalization} from "@smalox/shared";

export function DisabledChip() {
	const {t} = useLocalization();
	return <Chip icon={<DoNotDisturb />} label={t("disabled")} />;
}
